import { post } from '../axios'

// 工作台权限管理-添加角色
export function v1_portal_role_add_post(map, option) {
  return post(`${process.env.VUE_APP_V1}/v1/portal/role/add`, map, option).then(
    response => response
  )
}

// 工作台权限管理-查询所有角色
export function v1_portal_role_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/role/list`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-删除角色
export function v1_portal_role_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/role/delete`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-更新角色名称
export function v1_portal_role_update_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/role/update`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-批量给角色关联模块
export function v1_portal_role_batchModule_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/role/batchModule`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-给角色关联模块
export function v1_portal_role_assignModule_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/role/assignModule`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-根据用户ID查询所有的角色
export function v1_portal_role_byUserId_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/role/byUserId`,
    map,
    option
  ).then(response => response)
}
